import { useEffect, useMemo, useRef, useState } from "react";
import {
  getFormattedNumber,
  getNotNegativeNumber,
  isArrayEmpty,
  isStringEmpty,
} from "../../../utils/handler_validations";
import styles from "./styles";
import * as echarts from "echarts";
import classCharts from "../classCharts";
import SelectTime from "../SelectTime";
import { useDashboardContext } from "../../../context";

const getPropsTemplate = () => ({
  CSS: [""],
});

export const TripsChart = (props = getPropsTemplate()) => {
  const [chart, setChart] = useState();
  const dataDashboard = useDashboardContext();
  const CSS = ["div-tripsGrap"];
  const refDivChart = useRef();

  // cada que cambie el filtro => update chart
  useEffect(() => {
    const selectedData = getSelectedData();
    if (!chart) return;
    chart.setOption({
      grid: {
        top: 50,
        left: 60,
        right: 5,
      },
      legend: {
        orient: "horizontal",
        top: 0,
        left: "center",
        itemGap: 40,
        itemWidth: 20,
        itemHeight: 20,
        formatter: (name) => {
          switch (name) {
            case "completed":
              return "Completados";
            case "canceled":
              return "Cancelados";
            default:
              return name;
          }
        },
        textStyle: {
          color: "#13131d",
          fontSize: 14,
          fontFamily: "Roboto",
        },
      },
      xAxis: {
        type: "category",
        axisLabel: {
          interval: 0, // Muestra todas las etiquetas del eje x
          rotate: 0, // Rota las etiquetas
        },
      },
      yAxis: {},
      dataset: {
        dimensions: ["labelX", "completed", "canceled"],
        source: getFormattedDataset(selectedData.items),
      },
      series: [
        {
          type: "bar",
          barGap: "40%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0],
            color: "#16CA5E",
          },
          tooltip: {
            position: "top",
            backgroundColor: "#13131D",
            borderWidth: 0,
            padding: [0, 11, 0, 10],
            extraCssText: `border-radius: 20px;`,
            formatter: (params) => {
              const data = selectedData.items[params.dataIndex];
              return `
							<label style="
								color: #FFFFFF; 
								font-size: 12px;
								font-family: Roboto;
								font-weight: 400;
							">
								<label style="
									font-weight: 700; 
									font-size: 14px;
								">
									${getFormattedNumber(getNotNegativeNumber(data.completed?.total), true, 0)} /
								</label>
								$ ${getFormattedNumber(getNotNegativeNumber(data.completed?.earning), true, 2)}
							</label>`;
            },
          },
        },
        {
          type: "bar",
          barGap: "40%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0],
            color: "#D9D9D9",
          },
          tooltip: {
            position: "top",
            backgroundColor: "#13131D",
            borderWidth: 0,
            padding: [0, 11, 0, 10],
            extraCssText: `border-radius: 20px;`,
            formatter: (params) => {
              const data = selectedData.items[params.dataIndex];
              return `
							<label style="
								color: #FFFFFF; 
								font-size: 14px;
								font-family: Roboto;
								font-weight: 700;
							">
								${getFormattedNumber(getNotNegativeNumber(data.canceled), true, 0)}
							</label>`;
            },
          },
        },
      ],
      dataZoom:
        selectedData.scroll === 0
          ? undefined
          : [
              {
                type: "inside",
                start: 0,
                end: selectedData.scroll,
              },
              {
                start: 0,
                end: selectedData.scroll,
              },
            ],
    });
  }, [dataDashboard.filters?.tripsChart, chart]);

  // inializar chart
  useEffect(() => {
    if (!refDivChart?.current) setChart(undefined);
    const newChart = echarts.init(refDivChart.current);
    newChart.setOption({ tooltip: {} });
    setChart(newChart);
  }, [refDivChart?.current]);

  // cada que se establezca un nuevo obj chart
  useEffect(() => {
    window.addEventListener("resize", onChangeSizeWindow);
    return () => {
      if (chart) chart.dispose();
      window.removeEventListener("resize", onChangeSizeWindow);
    };
  }, [chart]);

  const getSelectedData = () => {
    let items = [classCharts.getItemTripTemplate()];
    items = dataDashboard.getDataTripsChart();
    switch (dataDashboard.filters?.tripsChart) {
      case "TODAY":
        return { items, scroll: 30 };
      case "WEEK":
        return { items, scroll: 100 };
      case "MONTH":
        return { items, scroll: 30 };
      default:
        return { items: [], scroll: 0 };
    }
  };

  const getFormattedDataset = (items = [classCharts.getItemTripTemplate()]) => {
    return items.map((item) => {
      return {
        labelX: item.label,
        completed: getNotNegativeNumber(item.completed?.total),
        canceled: getNotNegativeNumber(item.canceled),
      };
    });
  };

  const onChangeSizeWindow = () => {
    if (chart) chart.resize();
  };

  // add custom style
  if (!isArrayEmpty(props.CSS)) CSS.push(props.CSS.join(" "));
  if (!isStringEmpty(props.className)) CSS.push(props.className);

  return (
    <styles.DivMain className={CSS.join(" ")}>
      <div className="div-header">
        <label className="txt-title">Viajes completados / cancelados</label>
        <SelectTime
          onChangeValue={(newValue) => {
            dataDashboard.changeFilters({
              tripsChart: newValue,
            });
          }}
        />
      </div>
      <div className="div-separator" />
      <div className="div-chart" ref={refDivChart} />
    </styles.DivMain>
  );
};
